// Derives the status that should actually be shown for a campaign,
// independent of how stale the persisted status is. Manual states
// ("paused") always win; otherwise dates decide.
export const EFFECTIVE_STATUS = {
    SCHEDULED: "scheduled",
    RUNNING: "running",
    PAUSED: "paused",
    COMPLETED: "completed",
};

export const getEffectiveStatus = (campaign, now = new Date()) => {
    if (!campaign) return null;

    if (campaign.status === "paused") {
        return EFFECTIVE_STATUS.PAUSED;
    }

    // Persisted "ended" variants → completed.
    if (campaign.status === "status_ended" || campaign.status === "completed" || campaign.status === "ended") {
        return EFFECTIVE_STATUS.COMPLETED;
    }

    const start = campaign.startDate ? new Date(campaign.startDate) : null;
    const end = campaign.endDate ? new Date(campaign.endDate) : null;

    if (end && now >= end) {
        return EFFECTIVE_STATUS.COMPLETED;
    }
    if (start && now < start) {
        return EFFECTIVE_STATUS.SCHEDULED;
    }

    return EFFECTIVE_STATUS.RUNNING;
};
